import { FilterSourceModel } from '@leverege/molten/filters'
import { MultiSelector } from '@leverege/ui-elements'
import { GlobalState } from '@leverege/ui-redux'
import React, { useCallback, useEffect, useMemo, useState } from 'react'

export default function StationSelector( props ) {
  const {
    delegate,
    onChange : pOnChange,
    eventData,
    filter,
    ignored,
    disabled = false,
    emptyLabel = 'All Stations',
  } = props

  const [ options, setOptions ] = useState( [] )
  const value = useMemo( () => {
    return filter?.metadata || null
  }, [ filter ] )

  const onChange = useCallback(
    ( evt ) => {
      let f = FilterSourceModel.create()
      const conditions = []
      if ( evt.value && evt.value.length > 0 ) {
        conditions.push( {
          type : 'equals',
          field : 'data/name',
          value : evt.value,
          fieldType : 'string',
        } )
      }

      if ( ignored && ignored.length > 0 ) {
        conditions.push( {
          type : 'equals',
          field : 'data/name',
          value : ignored,
          fieldType : 'string',
          not : true,
        } )
      }

      if ( conditions.length > 0 ) {
        f = FilterSourceModel.setFilter( f, {
          type : 'logical',
          operator : 'and',
          conditions,
        } )
      }

      f = FilterSourceModel.setMetadata( f, evt.value )

      pOnChange( {
        value : f,
        data : evt.data,
      } )
    },
    [ pOnChange ],
  )

  useEffect( () => {
    const conditions = []
    const metadata = FilterSourceModel.getMetadata( filter )

    if ( metadata && metadata.length > 0 ) {
      conditions.push( {
        type : 'equals',
        field : 'data/name',
        value : metadata,
        fieldType : 'string',
      } )
    }

    if ( ignored && ignored.length > 0 ) {
      conditions.push( {
        type : 'equals',
        field : 'data/name',
        value : ignored,
        fieldType : 'string',
        not : true,
      } )
    }

    if ( conditions.length > 0 ) {
      const f = FilterSourceModel.setFilter( filter, {
        type : 'logical',
        operator : 'and',
        conditions,
      } )

      pOnChange( {
        data : eventData,
        value : f,
      } )
    }
  }, [] )

  useEffect( () => {
    let isMounted = true
    const getData = async () => {
      const res = await GlobalState.dispatch(
        delegate.search( {
          aggs : {
            agg : {
              type : 'terms',
              field : 'data/name',
            },
          },
          filter : ignored ?
            {
              type : 'logical',
              operator : 'and',
              conditions : [
                {
                  type : 'equals',
                  field : 'data/name',
                  value : ignored,
                  not : true,
                  fieldType : 'string',
                },
              ],
            } :
            null,
          limit : 0,
          queryName : 'stationSelector',
        } ),
      )

      const {
        aggs : {
          agg : { buckets },
        },
      } = res

      if ( isMounted ) {
        setOptions(
          buckets.map( bucket => ( {
            name : bucket.key,
            value : bucket.key,
          } ) ),
        )
      }
    }

    getData()

    return () => {
      isMounted = false
    }
  }, [ delegate ] )

  return (
    <MultiSelector
      disabled={disabled}
      emptyLabel={emptyLabel}
      selectionType="text"
      values={options}
      onChange={onChange}
      eventData={eventData}
      value={value}/>
  )
}
